<template>
  <el-dialog title="客户信息" :visible.sync="visibleCous" width="30%"  @close="()=>$emit('close')">
    <div class="list" v-for="(item, index) in customerList" :key="index">
      <div class="title">客户{{ index + 1 }}</div>
      <div class="info-list">
        <div class="info" v-for="(v, i) in item" :key="i">
          <div class="left-info-box">{{ v }}</div>
          <el-button
            size="mini" 
            @click="copyNow()"
            class="copybtn"
            :data-clipboard-text="v"
          >
            复制
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import Clipboard from "clipboard";
  export default {
    props: {
      visible: {
        type: Boolean,
        requird: false,
      },
      customerList: {
        type: Array,
        default: () => [["123", "456"], ["123"], ["1123"]],
      },
    },
    watch:{
        visible(val){
          this.visibleCous = val
        }
    },
    data() {
      return {
        visibleCous: false
      };
    },
    methods: {
      copyNow() {
        var clipboard = new Clipboard(".copybtn");
        clipboard.on("success", (e) => {
          this.$message.success("复制成功");
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          // 不支持复制
          this.$message.error("该浏览器不支持自动复制");
          // 释放内存
          clipboard.destroy();
        });
      }
    },
  };
</script>

<style lang="less" scoped>
.list{
  padding: 5px;
  .title{
    font-size: 14px;
    color: #000;
    margin-bottom: 5px;
  }
  .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 5px;
      .copybtn{
        background: #3572E2;
        color: #fff
      }
    }
    .left-info-box{
      flex:1;
      border:1px solid #eee;
      color:#888;
      padding:1px 5px;
      font-size: 12px;
      box-sizing: border-box;
      margin-right: 10px
    }
}
</style>
